import React, { useContext, useEffect, useState } from 'react';
import { Context } from "../index";
import {Button, Container, Navbar, Nav, Badge, NavDropdown} from "react-bootstrap";
import {NavLink, useLocation, useNavigate} from "react-router-dom";
import { observer } from "mobx-react-lite";
import {fetchFinUnreadCount, fetchUnreadCount} from "../http/userLogAPI";
import UserLogsModal from "./modals/logs/UserLogsModal";

import {
    ADMIN_ROUTE,
    MAIN_ROUTE,
    LOGIN_ROUTE,
    PRICING_ROUTE,
    REGISTRATION_ROUTE,
    USER_DASHBOARD_ROUTE,
    LIBRARY_ROUTE,
    PAY_ROUTE,
    KDP_TOOLS_ROUTE,
    POLL_LIBRARY_ROUTE,
    NEWS_ROUTE,
    STORE_ROUTE,
    ABOUT_ROUTE,
    HOW_IT_WORKS_ROUTE,
    GET_AMAZON_BOOK_REVIEWS_ROUTE,
    KDP_DISCOVERABILITY_ROUTE,
    BOOK_MARKETING_ROUTE,
    KDP_NICHE_RESEARCH_ROUTE,
    KDP_KEYWORD_RESEARCH_ROUTE,
    KDP_PROBLEMS_ROUTE,
    KDP_EARNINGS_ROUTE,
    AMAZON_ADS_FOR_BOOKS_ROUTE,
    PUBLIC_BOOK_LIBRARY_ROUTE,
} from "../utils/consts";
import MaintenanceBanner from "./admin/maintenance";
import {getCustomerPortalUrl} from "../http/userAPI";
import {
    FaBookOpen, FaChartLine,
    FaCoins, FaCompass,
    FaInfoCircle,
    FaPlayCircle,
    FaPoll, FaSignInAlt, FaStar,
    FaTags,
    FaUserPlus,
    FaWallet
} from "react-icons/fa";
import UserFinancialLogsModal from "./modals/logs/UserFinancialLogsModal";
import {FaBox} from "react-icons/fa6";
import {astroHref} from "../utils/astroLinks";

const NavBar = observer(({ isAuth }) => {
    const { user, book, poolStore } = useContext(Context);
    const navigate = useNavigate();
    const [currentAuth, setCurrentAuth] = useState(isAuth);
    const [showModal, setShowModal] = useState(false);
    const [showFinModal, setShowFinModal] = useState(false);
    const isFreePlan = user?.user?.tariff_plan === "FREE";
    const location = useLocation();
    const [expanded, setExpanded] = useState(false);

    const handleGoToCustomerPortal = async () => {
        const url = await getCustomerPortalUrl(user?.user?.stripe_customer_id);
        if (url) {

            window.open(url, "_blank"); // 🔥 Открываем в новой вкладке
        }
    };

    useEffect(() => {
        setCurrentAuth(isAuth);
    }, [isAuth]);


    useEffect(() => {
        if (user.user.id) {
            const timeout = setTimeout(() => {
                fetchUnreadCount(user.user.id).then(count => user?.setReadCountVirt(count));
                fetchFinUnreadCount(user.user.id).then(count => user?.setReadCountUsd(count));
            }, 1000); // Задержка 1 секунда

            return () => clearTimeout(timeout); // Очистка таймера при размонтировании
        }
    }, [user.user.id, user.user.balance, user.user.lr_balance, user, user?.activeComponent, user?.readCountVirt]);


    const isAdmin = user.user?.role === 'ADMIN';
    const isSuspended = user.user?.tariff_plan === "SUSPENDED";
    const displayName = user?.user?.username || user?.user?.email || "User";
    const rawAvatarUrl = user?.user?.profile_picture || user?.user?.avatar || "";
    const avatarUrl = typeof rawAvatarUrl === "string" && rawAvatarUrl.trim() && rawAvatarUrl !== "null"
        ? rawAvatarUrl.trim()
        : "";
    const userInitial = String(displayName).trim().charAt(0).toUpperCase() || "U";

    const logOut = () => {
        localStorage.removeItem('token');
        user.setUser({});
        user.setIsAuth(false);
        book.setSelectedLanguage('');
        book.setSelectedGenre('');
        book.setSelectedPrice('');
        book.setSelectedAssType('');
        user.setActiveComponent("")
        window.location.assign(MAIN_ROUTE);
    };

    return (
        <>
            <MaintenanceBanner />
                       <Navbar expand="lg"
                    expanded={expanded}
                    onToggle={() => setExpanded((prev) => !prev)}
                    className="spa-site-navbar fixed-top"
                    style={{
                        position: "fixed",
                        top: 0,
                        right: 0,
                        left: 0,
                        zIndex: 1000,
                        border: 0,
                        borderBottom: "1px solid rgba(101, 211, 181, 0.2)",
                        borderRadius: ".2rem",
                        background: "linear-gradient(90deg, rgba(0, 39, 53, 0.96), rgba(5, 83, 72, 0.95)), #002735",
                        boxShadow: "0 14px 30px rgba(0, 18, 27, 0.18)",
                    }}
            >
                <Container fluid={true} className={"px-3 py-1"}>
                    <Navbar.Brand href={astroHref(MAIN_ROUTE)}>
                        <img
                            src="https://virtalibry.com/logo/Virtalibry_logo_sub_no_bg.png"
                            alt="Virtalibry Logo"
                            width="210"
                            height="35"
                            className="d-inline-block align-top me-2"
                        />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="main-navbar" />
                    <Navbar.Collapse id="main-navbar" className="center">
                        <Nav
                            className="d-flex flex-wrap align-items-center w-100"
                        >
                            {currentAuth && !isSuspended ? (
                                <>
                                    <Button
                                        onClick={() => {
                                            window.location.assign(astroHref(PUBLIC_BOOK_LIBRARY_ROUTE));
                                            setExpanded(false);
                                        }}
                                        style={{ transition: "0.3s" }}
                                        variant="outline-success"
                                        className="m-1 btn btn-sm"
                                        title="ARC Book Library - Public Astro Library"
                                    >
                                        <FaBookOpen className="me-2 mb-1" />
                                        ARC
                                    </Button>

                                    <Button
                                        onClick={() => {
                                            book.setSelectedLanguage('');
                                            book.setSelectedGenre('');
                                            book.setSelectedPrice('');
                                            book.setSelectedAssType('');
                                            user.setActiveComponent("")
                                            navigate(POLL_LIBRARY_ROUTE);
                                            setExpanded(false);
                                        }}
                                        style={{ transition: "0.3s" }}
                                        variant={location.pathname === POLL_LIBRARY_ROUTE ? "success" : "outline-success"}
                                        className="m-1 btn btn-sm"
                                        title="Poll Library - Take Polls and Earn Virt"
                                    >
                                        <FaPoll className="me-2 mb-1" />
                                        Poll's
                                    </Button>

                                    <Button
                                        onClick={() => {
                                            book.setSelectedLanguage('');
                                            book.setSelectedGenre('');
                                            book.setSelectedPrice('');
                                            book.setSelectedAssType('');
                                            user.setActiveComponent("")
                                            navigate(LIBRARY_ROUTE);
                                            setExpanded(false);
                                        }}
                                        style={{ transition: "0.3s" }}
                                        variant={location.pathname === LIBRARY_ROUTE ? "success" : "outline-success"}
                                        className="m-1 btn btn-sm"
                                        title="Book Library - Search Books to Read and Earn Virt"
                                    >
                                        <FaBookOpen className="me-2 mb-1 " />
                                        Book Library
                                    </Button>
                                    <Button
                                        onClick={() => {
                                            book.setSelectedLanguage('');
                                            book.setSelectedGenre('');
                                            book.setSelectedPrice('');
                                            book.setSelectedAssType('');
                                            user.setActiveComponent("")
                                            navigate(STORE_ROUTE);
                                            setExpanded(false);
                                        }}
                                        style={{ transition: "0.3s" }}
                                        variant={location.pathname === STORE_ROUTE ? "success" : "outline-success"}
                                        className="m-1 btn btn-sm"
                                        title="Book Library - Search Books to Read and Earn Virt"
                                    >
                                        <FaBox className="me-2 mb-1" />
                                        Product Store
                                    </Button>

                                    <Button
                                        onClick={() => {
                                            navigate(NEWS_ROUTE);
                                            setExpanded(false);
                                        }}
                                        variant={location.pathname.startsWith(NEWS_ROUTE) ? "success" : "outline-success"}
                                        className="m-1 btn btn-sm"
                                        title="News & Updates"
                                    >
                                        <i className="bi bi-megaphone me-2"></i>
                                        News
                                    </Button>

                                    <Button
                                        onClick={() => {
                                            book.setSelectedCurrentUserAssign({});
                                            book.setSelectedCurrentUserBook({});
                                            poolStore.setSelectedPoolItem({});
                                            poolStore.setSelectedPool({});
                                            user.setActiveComponent("MainPageDashboard");
                                            navigate(USER_DASHBOARD_ROUTE);
                                            setExpanded(false);
                                        }}
                                        variant={location.pathname === USER_DASHBOARD_ROUTE && user?.activeComponent === "MainPageDashboard" ? "success" : "outline-success"}
                                        style={{   transition: "0.3s" }}
                                        className="m-1 btn btn-sm"
                                        title="Dashboard - Your Personal Dashboard"
                                    >
                                        <i className="bi bi-grid me-2"></i>
                                        Dashboard
                                    </Button>

                                    <Button
                                        onClick={() => {
                                            if (isFreePlan) {
                                                navigate(PAY_ROUTE);
                                            } else {
                                                handleGoToCustomerPortal();
                                            }
                                            setExpanded(false);
                                        }}
                                        variant="outline-success"
                                        className="m-1 fw-bolder btn btn-sm"
                                        alt="Tariff"
                                        style={{   transition: "0.3s" }}
                                        title="Your Current Tariff - Click to Manage Your Subscription"

                                    >
                                        {isFreePlan ? ( <i className="bi bi-star me-2"></i>) : (<i className="bi bi-award me-2"></i>)}

                                        {user?.user?.tariff_plan || "NO"}
                                    </Button>


                                    {/* ✅ Кнопка баланса с индикатором  <FaVirtIconW size={16} className="text-primary"
                                                     style={{ marginTop: "0px", marginBottom: "6px", marginLeft: "10px", marginRight: "2px" }} />
                                                     style={{...balanceButtonStyle, transition: "0.3s" }} непрочитанных логов */}
                                    <Button

                                        className="m-1 fw-bold border-success bg-opacity-50 position-relative btn btn-sm"
                                        onClick={() => {
                                            user?.setActiveComponent("VirtBalanceLogs");
                                            book.setSelectedCurrentUserAssign({});
                                            book.setSelectedCurrentUserBook({});
                                            poolStore.setSelectedPoolItem({});
                                            poolStore.setSelectedPool({});

                                            navigate(USER_DASHBOARD_ROUTE);
                                            setExpanded(false);}}

                                        variant={user?.activeComponent === "VirtBalanceLogs" ? "success" : "outline-success"}
                                        style={{   transition: "0.3s" }}
                                        title="Your Virt Balance - Click to View Your Balance Logs and Make Transfers"

                                    >
                                        <FaWallet
                                            className={`me-2 ${user?.readCountVirt > 0 ? 'animate__animated animate__wobble animate__infinite' : ''}`}
                                            style={{ position: 'relative', top: '-2px' }}
                                        />
                                        {Number(user.user?.balance)} Virt

                                        {user?.readCountVirt > 0 && (
                                            <Badge bg="success" pill className="position-absolute top-0 start-100 translate-middle">
                                                {user?.readCountVirt}
                                            </Badge>
                                        )}
                                    </Button>
                                    <Button
                                        variant={user?.activeComponent === "UsdBalanceLogs" ? "success" : "outline-success"}
                                        style={{   transition: "0.3s" }}
                                        className="m-1 fw-bold border-success bg-opacity-50 position-relative btn btn-sm"


                                        onClick={() => {
                                            user?.setActiveComponent("UsdBalanceLogs");
                                            book.setSelectedCurrentUserAssign({});
                                            book.setSelectedCurrentUserBook({});
                                            poolStore.setSelectedPoolItem({});
                                            poolStore.setSelectedPool({});

                                            navigate(USER_DASHBOARD_ROUTE);
                                            setExpanded(false);}}
                                        title="Your USD Balance - Click to View Your Balance Logs and Order Polls"
                                    >
                                        <FaCoins className="me-2 animate__animated animate__repeat-1 animate__bounce animate__infinite" style={{ position: 'relative', top: '-2px' }} />
                                        ${Number(user.user?.lr_balance).toFixed(2)}

                                        {user?.readCountUsd > 0 && (
                                            <Badge bg="success" pill className="position-absolute top-0 start-100 translate-middle">
                                                {user?.readCountUsd}
                                            </Badge>
                                        )}

                                    </Button>
                                    <Button
                                        variant={user?.activeComponent === "Affiliate" ? "success" : "outline-success"}
                                        style={{transition: "0.3s"}}
                                        className="m-1 fw-bold border-success bg-opacity-50 position-relative btn btn-sm"


                                        onClick={() => {
                                            user?.setActiveComponent("Affiliate");
                                            book.setSelectedCurrentUserAssign({});
                                            book.setSelectedCurrentUserBook({});
                                            poolStore.setSelectedPoolItem({});
                                            poolStore.setSelectedPool({});

                                            navigate(USER_DASHBOARD_ROUTE);
                                            setExpanded(false);
                                        }}
                                        title="Your Affiliate Balance - Click to View Affiliate Program"
                                    >
                                        <i className="fa-solid fa-hand-holding-dollar me-2"
                                           style={{position: 'relative', top: '-0.3px'}}></i>
                                        ${Number(user.user?.affiliate_balance).toFixed(2)}


                                    </Button>

                                    <Button
                                        variant="outline-success"
                                        onClick={() => {
                                            logOut();
                                            setExpanded(false);
                                        }}
                                        className="m-1 btn btn-sm"
                                        title="Logout"
                                    >
                                        <i className="bi bi-box-arrow-in-right me-1"></i>

                                    </Button>


                                    {isAdmin && (
                                        <Button
                                            variant={location.pathname === ADMIN_ROUTE ? "success" : "outline-success"}
                                            className="m-1 text btn btn-sm"
                                            style={{ transition: "0.3s" }}
                                            onClick={() => {
                                                navigate(ADMIN_ROUTE);
                                                setExpanded(false);
                                            }}
                                            title="Admin Panel"
                                        >
                                            <i className="bi bi-shield-lock"></i>
                                        </Button>


                                    )}



                                </>
                            ) : (
                                <>
                                    {currentAuth && isSuspended ? (
                                        <div className="d-flex w-100 justify-content-center align-items-center gap-2 my-1">
                                            <div className="alert alert-danger fw-bold fs-4 py-1 px-2 mb-0" role="alert">
                                                THIS ACCOUNT IS SUSPENDED
                                            </div>
                                            <Button
                                                variant="outline-success"
                                                onClick={() => { logOut(); setExpanded(false); }}
                                                className="btn btn-sm p-1 px-2"
                                                title="Logout"
                                            >
                                                <i className="bi bi-box-arrow-in-right me-1"></i>
                                                Logout
                                            </Button>
                                        </div>
                                    ) : (
                                        <Nav style={{ marginLeft: "-5px" }}>
                                            <Nav.Link
                                                href={astroHref(PUBLIC_BOOK_LIBRARY_ROUTE)}
                                                className="nav-seo-link"
                                                onClick={() => setExpanded(false)}
                                            >
                                                <svg
                                                    className="me-1 text-success"
                                                    viewBox="0 0 576 512"
                                                    style={{ width: "1em", height: "1em", position: "relative", top: "-2px", fill: "currentColor" }}
                                                    aria-hidden="true"
                                                    focusable="false"
                                                >
                                                    <path d="M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z" />
                                                </svg>
                                                ARC
                                            </Nav.Link>

                                            <Nav.Link
                                                as={NavLink}
                                                to={HOW_IT_WORKS_ROUTE}
                                                className="nav-seo-link"
                                                onClick={() => setExpanded(false)}
                                            >
                                                <FaPlayCircle style={{ position: "relative", top: "-2px" }} className="me-1 text-success" />
                                                How It Works
                                            </Nav.Link>

                                            <Nav.Link
                                                as={NavLink}
                                                to={GET_AMAZON_BOOK_REVIEWS_ROUTE}
                                                className="nav-seo-link"
                                                onClick={() => setExpanded(false)}
                                            >
                                                <FaStar style={{ position: "relative", top: "-2px" }} className="me-1 text-success" />
                                                Get Reviews
                                            </Nav.Link>

                                            <Nav.Link
                                                as={NavLink}
                                                to={KDP_TOOLS_ROUTE}
                                                className="nav-seo-link"
                                                onClick={() => setExpanded(false)}
                                            >
                                                <FaChartLine style={{ position: "relative", top: "-2px" }} className="me-1 text-success" />
                                                KDP Tools
                                            </Nav.Link>

                                            <NavDropdown
                                                title={
                                                    <span className="nav-seo-link">
                <FaCompass style={{ position: "relative", top: "-2px" }} className="me-1 text-success" />
                KDP Guides
            </span>
                                                }
                                                id="kdp-guides-dropdown"
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                <NavDropdown.Item
                                                    as={NavLink}
                                                    to={KDP_DISCOVERABILITY_ROUTE}
                                                    onClick={() => setExpanded(false)}
                                                >
                                                    Discoverability
                                                </NavDropdown.Item>

                                                <NavDropdown.Item
                                                    as={NavLink}
                                                    to={BOOK_MARKETING_ROUTE}
                                                    onClick={() => setExpanded(false)}
                                                >
                                                    Marketing
                                                </NavDropdown.Item>
                                                <NavDropdown.Item
                                                    as={NavLink}
                                                    to={AMAZON_ADS_FOR_BOOKS_ROUTE}
                                                    onClick={() => setExpanded(false)}
                                                >
                                                    Amazon ADS
                                                </NavDropdown.Item>


                                                <NavDropdown.Item
                                                    as={NavLink}
                                                    to={KDP_NICHE_RESEARCH_ROUTE}
                                                    onClick={() => setExpanded(false)}
                                                >
                                                    Niche Research
                                                </NavDropdown.Item>

                                                <NavDropdown.Item
                                                    as={NavLink}
                                                    to={KDP_KEYWORD_RESEARCH_ROUTE}
                                                    onClick={() => setExpanded(false)}
                                                >
                                                    Keyword Research
                                                </NavDropdown.Item>

                                                <NavDropdown.Item
                                                    as={NavLink}
                                                    to={KDP_PROBLEMS_ROUTE}
                                                    onClick={() => setExpanded(false)}
                                                >
                                                    KDP Problems
                                                </NavDropdown.Item>

                                                <NavDropdown.Item
                                                    as={NavLink}
                                                    to={KDP_EARNINGS_ROUTE}
                                                    onClick={() => setExpanded(false)}
                                                >
                                                    KDP Earnings
                                                </NavDropdown.Item>
                                            </NavDropdown>

                                            <Nav.Link
                                                as={NavLink}
                                                to={PRICING_ROUTE}
                                                className="nav-seo-link"
                                                onClick={() => setExpanded(false)}
                                            >
                                                <FaTags style={{ position: "relative", top: "-2px" }} className="me-1 text-success" />
                                                Pricing
                                            </Nav.Link>

                                            <Nav.Link
                                                as={NavLink}
                                                to={ABOUT_ROUTE}
                                                className="nav-seo-link"
                                                onClick={() => setExpanded(false)}
                                            >
                                                <FaInfoCircle style={{ position: "relative", top: "-2px" }} className="me-1 text-success" />
                                                About
                                            </Nav.Link>

                                            <Nav.Link
                                                as={NavLink}
                                                to={REGISTRATION_ROUTE}
                                                className="nav-seo-link"
                                                onClick={() => setExpanded(false)}
                                            >
                                                <FaUserPlus style={{ position: "relative", top: "-2px" }} className="me-1 text-success" />
                                                Sign up
                                            </Nav.Link>

                                            <Nav.Link
                                                as={NavLink}
                                                to={LOGIN_ROUTE}
                                                className="nav-seo-link"
                                                onClick={() => setExpanded(false)}
                                            >
                                                <FaSignInAlt style={{ position: "relative", top: "-2px" }} className="me-1 text-success" />
                                                Sign in
                                            </Nav.Link>
                                        </Nav>





                                    )}
                    </>
                    )}
                        </Nav>
                        {currentAuth && !isSuspended && (
                        <div className="spa-navbar-user d-none d-lg-flex align-items-center ms-auto me-2"
                             style={{ maxWidth: '240px', lineHeight: '1.25', fontSize: '0.9rem' }}>
                            <span className="spa-navbar-user__avatar" aria-hidden="true">
                                {avatarUrl ? (
                                    <img src={avatarUrl} alt="" referrerPolicy="no-referrer" />
                                ) : (
                                    userInitial
                                )}
                            </span>
                            <span className="spa-navbar-user__details">
                                <small className="spa-navbar-user__name text-truncate" title={`Welcome back, ${displayName}`}>
                                    Welcome back, <strong>{displayName}</strong>
                                </small>
                                <small className="spa-navbar-user__email text-truncate" title={`Your Email: ${user?.user?.email}`}>
                                    {user?.user?.email} / {user?.user?.id}
                                </small>
                            </span>
                        </div>
                            )}

                        {currentAuth && isSuspended && (
                            <div className="spa-navbar-user d-none d-lg-flex align-items-center ms-auto me-2"
                                 style={{ maxWidth: '240px', lineHeight: '1.25', fontSize: '0.9rem' }}>
                                <span className="spa-navbar-user__avatar" aria-hidden="true">
                                    {avatarUrl ? (
                                        <img src={avatarUrl} alt="" referrerPolicy="no-referrer" />
                                    ) : (
                                        userInitial
                                    )}
                                </span>
                                <span className="spa-navbar-user__details">
                                    <small className="spa-navbar-user__name text-truncate" title={`Welcome back, ${displayName}`}>
                                        Account Suspended, <strong>{displayName}</strong>
                                    </small>
                                    <small className="spa-navbar-user__email text-truncate" title={`Your Email: ${user?.user?.email}`}>
                                        {user?.user?.email} / {user?.user?.id}
                                    </small>
                                </span>
                            </div>
                        )}



                    </Navbar.Collapse>
                </Container>

            </Navbar>




            {/* ✅ Модальное окно логов */}
            <UserLogsModal show={showModal} handleClose={() => setShowModal(false)} />
            <UserFinancialLogsModal show={showFinModal} handleClose={() => setShowFinModal(false)} />
        </>
    );
});

    export default NavBar;
